import { useQuery } from '@tanstack/react-query';

import type { PracticeResponse } from '../@types/practices';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

interface UseGetPractice {
  organizationId: string;
  practiceId: string;
}

export const useGetPractice = ({
  organizationId,
  practiceId,
}: UseGetPractice) => {
  const practiceApiPath = `/${endpoints.organizations}/${organizationId}/${endpoints.practices}/${practiceId}`;
  return useQuery([practiceApiPath, organizationId, practiceId], () =>
    makeAPIRequestReactQuery<PracticeResponse>(practiceApiPath, { details: 'practice' }),  // Request practice details only
  );
};
